import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Countdown from 'react-countdown';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import { setCookie, getCookie } from '../helpers/cookies';
import { BaseButton, FlexDiv } from '../styles/styled';
import Colors from '../styles/colors';
const {
  isPublisherPlan,
  isPublisherReferredByPartner,
  isWithinDaysRange,
  getPartners,
  getPartnerCodes,
  getPartnerCodesValidity,
} = require('../../server/scripts/utils')();

const PartnerBanner = props => {
  const activeBanner = true;
  const activePartner = 'stackcommerce';
  const excludedRoutes = ['/buy'];
  const cookie = 'sw-pbanner';
  const { publisher } = props.userInfo;
  const [show, setShow] = useState(false);
  const [countdown, setCountdown] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const isExcludedRoute = excludedRoutes.find(excludedRoute => {
      return location.pathname.includes(excludedRoute);
    });

    if (activeBanner && !isExcludedRoute && !isEmpty(publisher)) {
      handleBannerVisibility();
    }
  }, [publisher]);

  const handleBannerVisibility = () => {
    const { created = null } = publisher || {};
    // make sure this banner only show for specific condition
    const isStarterPlan = isPublisherPlan('starter', publisher);
    const isReffered = isPublisherReferredByPartner(activePartner, publisher);
    const past = moment.unix(created);
    const isWithinValidDateRange = isWithinDaysRange(past, getPartnerCodesValidity());
    if (isStarterPlan && isReffered && isWithinValidDateRange) {
      const ncountdown = moment.unix(created).add(getPartnerCodesValidity(), 'days').toDate();
      setCountdown(ncountdown);

      // read cookie if the user already closed this banner
      const bannerState = getCookie(cookie);
      if (isEmpty(bannerState)) {
        setShow(true);
        props.onBannerUpdate(true);
      }
    } else {
      setShow(false);
    }
  };

  const handleSignup = () => {
    const query = () => {
      const { created = null, referredBy = '' } = publisher || {};
      // if reffered by partner, check for partner code attachments
      const isStarterPlan = isPublisherPlan('starter', publisher);
      const isReffered = isPublisherReferredByPartner(activePartner, publisher);
      const past = moment.unix(created);
      const isWithinValidDateRange = isWithinDaysRange(past, getPartnerCodesValidity());
      if (isStarterPlan && isReffered && isWithinValidDateRange) {
        const partnerCodes = getPartnerCodes(referredBy);
        return `?discount=${partnerCodes[0]}`;
      }

      return '';
    };

    history.push(`/pricing${query()}`);
  };

  const handleClose = () => {
    setShow(false);
    // setCookie(cookie, 'hide');
    props.onBannerUpdate(false);
  };

  const countdownRenderer = useCallback(
    props => {
      const { days, hours, minutes, seconds } = props.formatted;
      return (
        <TimerBlock>
          <div className="twrapper">
            <div className="tbody">
              <div className="tblock">
                <div className="tdigits theme-color title-small">{days}</div>
                <div className="tlabel">
                  <span className="text-small2">Days</span>
                </div>
              </div>
              <div className="tcolon title-small">:</div>
              <div className="tblock">
                <div className="tdigits theme-color title-small">{hours}</div>
                <div className="tlabel">
                  <span className="text-small2">Hours</span>
                </div>
              </div>
              <div className="tcolon title-small">:</div>
              <div className="tblock">
                <div className="tdigits theme-color title-small">{minutes}</div>
                <div className="tlabel">
                  <span className="text-small2">Mins</span>
                </div>
              </div>
              <div className="tcolon title-small">:</div>
              <div className="tblock">
                <div className="tdigits theme-color title-small">{seconds}</div>
                <div className="tlabel">
                  <span className="text-small2">Secs</span>
                </div>
              </div>
            </div>
          </div>
        </TimerBlock>
      );
    },
    [publisher]
  );

  if (!show) {
    return null;
  }

  const bannerTitle =
    'Upgrade to get 20% off on all publisher subscription plans. Your existing payment for the starter plan applied as credit. Offer ends in ';
  return (
    <BannerWrapper className="bg-dark-cherry position-relative">
      <div className="content sm-padding-five xs-padding-five text-center text-white text-medium xs-text-large xs-width-90">
        <FlexDiv alignItems="center" justifyContent="center">
          {bannerTitle}
          {!!countdown && <Countdown date={countdown} renderer={countdownRenderer} />}
          <SignUpButton onClick={handleSignup}>Upgrade</SignUpButton>
          <CloseButton onClick={handleClose}>✕</CloseButton>
        </FlexDiv>
      </div>
    </BannerWrapper>
  );
};

const BannerWrapper = styled.div`
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    ${FlexDiv} {
      flex-direction: column;
    }
  }

  .content {
    width: 100%;
  }

  .with-promo {
    @media (max-width: 767px) {
      display: block;
      margin: 0 auto !important;
      margin-top: 10px !important;
    }
  }
`;

const SignUpButton = styled(BaseButton)`
  padding: 5px 30px;
  border-radius: 5px;
  border-color: ${Colors.mainOrange};
  transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) 0s;

  @media (max-width: 991px) {
    padding: 5px 30px;
  }

  &:hover {
    transform: translateX(3px);
  }
`;

const CloseButton = styled.div`
  position: absolute;
  top: 34%;
  right: 20px;
  cursor: pointer;
`;

const TimerBlock = styled.div`
  z-index: 1002;
  text-align: center;
  padding: 0 16px;

  .twrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .thead {
      color: #fff;
    }

    .tbody {
      display: flex;
      align-items: flex-start;
    }

    .tblock {
      display: inline-block;

      .tdigits {
        display: inline-block;
        font-weight: 700;
      }

      .tlabel {
        display: block;
        color: #fff;
        margin-top: -10px;
      }
    }

    .tcolon {
      padding: 0px 5px;
      color: #fff;
    }
  }
`;

PartnerBanner.propTypes = {
  history: PropTypes.object,
  userInfo: PropTypes.object,
  onBannerUpdate: PropTypes.func,
};

PartnerBanner.defaultProps = {
  history: {},
  userInfo: {},
  onBannerUpdate: () => {},
};

export default PartnerBanner;
